/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Bulk_Destructive_WarningInputs */



/**
* | output |
* | --- |
* | "Cannot be undone — review before approving." |
*
* @param {Chat_Tool_Bulk_Destructive_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_bulk_destructive_warning = /** @type {((inputs?: Chat_Tool_Bulk_Destructive_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Bulk_Destructive_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lässt sich nicht rückgängig machen — vor dem Genehmigen prüfen.")
	return /** @type {LocalizedString} */ ("Cannot be undone — review before approving.")
});